import { WatchlistApi } from '../../../api/user';
import { GlobalSettingsKeys } from '../../../api/models/GlobalSettingsKeys';
import { Registry } from '@lightningjs/sdk';
import { randIntInRange } from '../../utility/Utility';
import { Backend } from '../../../api/Backend';
import { AssetType } from '../../../api/models/Shared.types';
import { WatchlistID } from '../../../api/user/WatchlistApi.types';

export class WatchlistHandler {
  private _backend: Backend;
  private _id: string;
  private _type: AssetType;
  private _watchlistTimer: number | undefined;
  constructor(backend: Backend, id: string, type: AssetType) {
    this._backend = backend;
    this._id = id;
    this._type = type;
  }

  start() {
    if (!this._watchlistTimer) {
      const baseTime = this._backend.globalSettings.numberValue(GlobalSettingsKeys.playerWatchlistTime) || 300000;
      const rand = this._backend.globalSettings.numberValue(GlobalSettingsKeys.playerWatchlistTimeRandomMs) || 300000;
      const timeInterval = randIntInRange(baseTime, baseTime + rand);
      this._watchlistTimer = Registry.setInterval(() => this._addToWatchlist(), timeInterval);
    }
  }

  stop() {
    if (this._watchlistTimer) {
      Registry.clearInterval(this._watchlistTimer);
      this._watchlistTimer = undefined;
    }
  }

  _addToWatchlist() {
    const requestInfo: WatchlistID = {
      id: this._id,
      type: this._type,
      profileId: this._backend.deviceProfile?.id,
    };

    WatchlistApi.update(this._backend, requestInfo);
  }
}
